export const LIST = 'prevenx/company/LIST'
export const LIST_ERROR = 'prevenx/company/LIST_ERROR'
export const SELECT = 'prevenx/company/SELECT'
